// services/feedback.send.page.service.ts
import { BaseCaptchaService } from '../../services/base-captcha.service';
import { ServerHandler } from '../../common/server/serverHandler';

export class FeedbackSendPageService extends BaseCaptchaService
{
    private successFlag = false;

    public isSuccess(): boolean {
        return this.successFlag;
    }

    async sendFeedback(
      feedbackForm: HTMLFormElement,
      sidePopup: HTMLElement | null,
      loader: HTMLElement | null,
      selectedFiles: File[]
    ): Promise<{message: string} | undefined> {

        // Проверяем наличие данных капчи
        if (!this.hasCaptchaData()) {
            this.showMessage(
              sidePopup,
              'Ошибка',
              'Пожалуйста, пройдите каптчу'
            );
            return;
        }

        this.successFlag = false;
        loader?.classList.add('active');

        // Создаем FormData
        const formData = new FormData(feedbackForm);

        // Добавляем файлы
        selectedFiles.forEach((file) => {
            formData.append('documents[]', file);
        });

        // Добавляем данные капчи через базовый метод
        try {
            this.addCaptchaToFormData(formData);
        } catch (error) {
            loader?.classList.remove('active');
            this.showMessage(
              sidePopup,
              'Ошибка',
              'Данные капчи не найдены. Пожалуйста, пройдите каптчу заново.'
            );
            return;
        }

        try {
            const response = await fetch('/feedback/Ask', {
                method: 'POST',
                body: formData
            }).then((data: any) => {
                if (ServerHandler.successAnswer(data.status)) {
                    this.resetCaptchaData();
                    this.showMessage(
                      sidePopup,
                      'Спасибо за обращение!',
                      'В ближайшее время мы с вами свяжемся.'
                    );
                }
                return data;
            });
            const data = await response.json();

            if (!response.ok) {
                throw new Error(`Status: ${response.status}|${data.message || ''}`);
            }

            this.successFlag = true;
            loader?.classList.remove('active');
            feedbackForm.reset();

            return data;

        } catch (error) {
            loader?.classList.remove('active');

            const errorStr = error instanceof Error ? error.message : '';
            const [statusStr, messageStr] = errorStr.split('|');
            const status = parseInt(statusStr.replace('Status: ', ''));

            let errorMessage = 'Не удалось отправить письмо, попробуйте позже';

            if (status === 429) {
                errorMessage = 'Капча не пройдена. Пожалуйста, попробуйте ещё раз';
                this.resetCaptchaData();
            } else if (status === 400) {
                if (messageStr?.includes('expired')) {
                    errorMessage = 'Время действия каптчи истекло. Пожалуйста, попробуйте ещё раз';
                    this.resetCaptchaData();
                } else {
                    errorMessage = messageStr || 'Пожалуйста, заполните все обязательные поля';
                }
            }

            this.showMessage(sidePopup, 'Ошибка', errorMessage);
            return;
        }
    }

    private showMessage(sidePopup: HTMLElement | null, title: string, message: string): void {
        if (!sidePopup) {
            alert(`${title}: ${message}`);
            return;
        }

        const titleElement = sidePopup.querySelector('h3');
        const textElement = sidePopup.querySelector('p');

        if (titleElement) titleElement.innerText = title;
        if (textElement) textElement.innerText = message;

        sidePopup.classList.add('active');

        if (title === 'Спасибо за обращение!') {
            setTimeout(() => {
                sidePopup.classList.remove('active');
            }, 5000);
        }
    }
    async verifyCaptcha(
      formData: FormData
    ): Promise<Response | null> {// {valid: boolean; message?: string}
        try {
            this.addCaptchaToFormData(formData);
            const response = await fetch('/captcha/slider/verify', {
                method: 'POST',
                body: formData
            })

            return await response;
        } catch (error) {
            return null;
        }
    }
}
